var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyBankDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "my-bank-details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 60 0 60 40 0 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 60 0 60 40 0 40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my-bank-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0003,7.37821732 C4.0003,5.51221802 5.6256849,4.0001 7.63029484,4.0001 L53.3712485,4.0001 C55.3749151,4.0001 57.0003,5.51221802 57.0003,7.37821732 L57.0003,9.0001 L4.0003,9.0001 L4.0003,7.37821732 Z M7.22836688,36.3636504 C5.23231202,36.3636504 3.61386378,34.7358973 3.61386378,32.7272009 L3.61386378,16.4364361 L56.3876755,16.4364361 L56.3876755,20.2865165 C57.736539,20.8706927 58.9548369,21.6987483 60.0003,22.7082955 L60.0003,7.27299914 C60.0003,3.25560619 56.7652822,0.0001 52.7741118,0.0001 L7.22836688,0.0001 C3.23625717,0.0001 0.0003,3.25560619 0.0003,7.27299914 L0.0003,32.7272009 C0.0003,36.7445938 3.23625717,40.0001 7.22836688,40.0001 L42.8173205,40.0001 C41.8141268,38.9480157 40.9922218,37.7210566 40.4107828,36.3636504 L7.22836688,36.3636504 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0798346,20 L10.9201654,20 C9.85927403,20 9,21.1848564 9,22.6447688 C9,24.1046811 9.85927403,25.2895375 10.9201654,25.2895375 L33.0798346,25.2895375 C34.1397659,25.2895375 35,24.1046811 35,22.6447688 C35,21.1848564 34.1397659,20 33.0798346,20",
    id: "Fill-4",
    fill: "#FCBC00",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1431813,27 L10.8568187,27 C9.83185476,27 9,28.1848564 9,29.6447688 C9,31.1046811 9.83185476,32.2895375 10.8568187,32.2895375 L25.1431813,32.2895375 C26.1681452,32.2895375 27,31.1046811 27,29.6447688 C27,28.1848564 26.1681452,27 25.1431813,27",
    id: "Fill-6",
    fill: "#FCBC00",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0003,9.0001 L3.0003,9.0001 L3.0003,7.37821732 C3.0003,5.51221802 4.6256849,4.0001 6.63029484,4.0001 L52.3712485,4.0001 C54.3749151,4.0001 56.0003,5.51221802 56.0003,7.37821732 L56.0003,9.0001 Z M19.5898172,36.3636504 C19.0093175,37.7220019 18.1864732,38.9480157 17.1842188,40.0001 L52.7731724,40.0001 C56.7643428,40.0001 60.0003,36.7445938 60.0003,32.7281461 L60.0003,7.27299914 C60.0003,3.25655146 56.7643428,0.0001 52.7731724,0.0001 L7.22742756,0.0001 C3.23625717,0.0001 0.0003,3.25655146 0.0003,7.27299914 L0.0003,22.7082955 C1.04576308,21.6987483 2.26500036,20.871638 3.61292446,20.2865165 L3.61292446,16.4364361 L56.3867362,16.4364361 L56.3867362,32.7281461 C56.3867362,34.7358973 54.768288,36.3636504 52.7731724,36.3636504 L19.5898172,36.3636504 Z",
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBankDetails);
export default __webpack_public_path__ + "static/media/my-bank-details.5d64592be4cfc5838a1ba91851f288db.svg";
export { ForwardRef as ReactComponent };